module.exports = __webpack_public_path__ + "bcf_logo_neg1-4981f9f45bb7c285a03e8ecefdd9018a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/bcf_logo_neg1.png
// module id = 1127
// module chunks = 0 1